(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/jotai/map-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/jotai/map-atoms.js');
"use strict";


const _jotai = jotai,
  atom = _jotai.atom;
const _jotaiUtils = jotaiUtils,
  atomWithStorage = _jotaiUtils.atomWithStorage;
setGlobal('svs.lyckoplatsen.shared_map.atoms', {
  isMovingAtom: atom(false),
  isCenteredAtom: atom(true),
  isUserIdleAtom: atom(false),
  mapZoomLevelAtom: atomWithStorage('mapZoomLevel', ''),
  mapFlyToLevelAtom: atom(false),
  locationNameAtom: atomWithStorage('locationName', '')
});

 })(window);